const navItems = [
  {
    content: "Home",
    path: "/home",
  },
  { content: "About", path: "/about" },
  {
    content: "Contact",
    path: "/contact",
  },
  {
    content: "Blogs",
    path: "/blogs",
  },
];

export default navItems;

